import './add-to-cart';
import './bear-slider';
import './image-slider';
import './nav';
import './parallax';
import './product-archive';
import './product-slider';
